import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("loom_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// On 402 (paywall), surface a toast with an Upgrade action.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const detail = err.response?.data?.detail || "Upgrade to unlock";
      // Free-upload limit → open the referral popup instead of a generic toast.
      if (/bonus upload/i.test(detail)) {
        window.dispatchEvent(new CustomEvent("loom:referral-needed", { detail }));
      } else {
        // dynamic import to avoid circular deps
        import("sonner").then(({ toast }) => {
          toast.error(detail, {
            action: { label: "Upgrade", onClick: () => { window.location.href = "/pricing"; } },
            duration: 6000,
          });
        });
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// Authenticated file download: fetches through the same axios client that powers
// every other API call (sends the session cookie for Google users AND the bearer
// token for email/password users), then saves the blob in-page. No new tab / no
// token-in-URL, so it works regardless of auth method.
export async function downloadFile(path, fallbackName) {
  const r = await api.get(path, { responseType: "blob" });
  const ct = (r.headers?.["content-type"] || "").toLowerCase();
  if (ct.includes("application/json")) {
    let detail = "Export failed";
    try { detail = JSON.parse(await r.data.text())?.detail || detail; } catch {}
    throw new Error(detail);
  }
  let name = fallbackName || "loom-export";
  const cd = r.headers?.["content-disposition"] || "";
  const m = /filename="?([^"]+)"?/.exec(cd);
  if (m) name = m[1];
  const url = window.URL.createObjectURL(new Blob([r.data], { type: ct || "application/octet-stream" }));
  const a = document.createElement("a");
  a.href = url; a.download = name; a.rel = "noopener";
  document.body.appendChild(a); a.click();
  setTimeout(() => { a.remove(); window.URL.revokeObjectURL(url); }, 1000);
}
